<template>
  <div class="notice">
    <div v-if="schoolCode === '10488'" data-v-af5d225e="" data-v-03dd2030="" class="header"  @click="goBack()">
      <div data-v-af5d225e="">
        <i data-v-af5d225e="" class="back"></i>
        <h3 data-v-af5d225e="">通知</h3>
      </div>
    </div>
    <Header v-else :title="schoolCode != '12763' ? '通知' : '审核消息'"></Header>
    <NOdata title="暂无消息~" v-if="this.msgLists.length == 0"></NOdata>

    <div v-else>
      <div v-for="(item, index) in msgLists" :key="index">
        <div class="notice-item">
          <h1 class="note-title">{{ item.msgTitle }}</h1>
          <p style="color:red" v-if="schoolCode != '13115'">
            如需操作，请登陆电脑版教务系统进行!
          </p>
          <p
            style="color:red"
            v-else-if="schoolCode == '13115' && item.msgTitle != '监考结果通知'"
          >
            如需操作，请登陆电脑版教务系统进行!
          </p>
          <p
            @click="cxdetail(item.msgTitle)"
            v-if="schoolCode == '10555' || schoolCode == '13115'"
            :class="item.isOpen ? '' : 'is-open'"
            v-html="item.msgDes"
          ></p>
          <p v-else :class="item.isOpen ? 'iszk' : 'is-open'">{{ item.msgDes }}</p>
          <div
            class="check-dtl"
            @click="
              item.isOpen = !item.isOpen;
              open(item.msgId);
            "
          >
            {{ item.isOpen ? "收起" : "展开" }}
          </div>
        </div>
        <div class="notice-time">{{ item.msgTime }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "../../utils/axios";
export default {
  data() {
    return {
      msgLists: [],
      schoolCode: sessionStorage.getItem("schoolCode")
    };
  },
  methods: {
    async cxdetail(title) {
      if ((this.schoolCode = "13115" && "监考结果通知" == title)) {
        this.$router.push({ path: "/invigilate" });
      }
    },
    async open(val) {
      if (this.$route.query.type == "1" || this.$route.query.type == "0") {
        const params = {
          msgId: val
        };
        const res = await Api.getMessageMarkRead(params);
      }
    },
    async getList_10555() {
      const res = await Api.dsNoticeList();
      this.msgLists = res.data.map((item, index) => {
        return {
          msgTitle: item.msgTitle,
          msgDes: item.msgDes,
          msgTime: item.msgTime,
          msgId: item.msgId,
          isOpen: false
        };
      });
    },
    async getList() {
      const params = {
        msgType: this.$route.query.type
      };
      const res = await Api.getNoticeList(params);
      let concatList = [];
      res.data.forEach((item, index) => {
        concatList[index] = {
          msgTitle: item.msgTitle,
          msgDes: item.msgDes,
          msgTime: item.msgTime,
          msgId: item.msgId,
          isOpen: false
        };
      });
      this.msgLists = this.msgLists.concat(concatList);
    },
    goBack() {
      this.$router.push({
        path: '/new/Msg_10488',
        query: {
          active:1
        }
      })
    }
  },
  created() {
    if (this.$route.query.type == "3") {
      this.getList_10555();
    } else {
      this.getList();
    }
  }
};
</script>

<style lang="less" scoped>
.black-title {
  display: flex;
  align-items: center;
}
.notice-item {
  margin: 20px 20px 0;
  background-color: @attendance-background-color-10;
  padding: 8px 16px;
  text-align: center;
}
.note-title {
  color: @attendance-color-1;
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 16px;
}
.notice-item p {
  font-size: 14px;
  color: @attendance-color-2;
}
.notice-item .is-open {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.check-dtl {
  padding-top: 8px;
  border-top: 1px solid @attendance-border-color-2;
  margin-top: 19px;
  color: @attendance-color-2;
  font-size: 12px;
}
.notice-time {
  text-align: center;
  color: @attendance-color-2;
  font-size: 12px;
  margin-top: 8px;
}
.iszk{
  word-wrap: break-word; /* 允许在单词内换行 */
  word-break: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Notice.vue